<div [id]="model.sectionId">
  <ng-template view></ng-template>
</div>
